import { useState } from "react"
import { useAppDispatch } from "../../../../state/store"
import { ProductVariant } from "../../../../types/product"
import { addToBasket } from "../../state/actions/addToBasket"
import { changeQuantity } from "../../state/actions/changeQuantity"
import { changeVariant } from "../../state/actions/changeVariant"
import { removeFromBasket } from "../../state/actions/removeFromBasket"
import { setSamples } from "../../state/actions/setSamples"
import { toggleGift } from "../../state/actions/toggleGift"
import { Basket, BasketItem } from "../../state/checkoutTypes"
import { BasketSample } from "../types/basket"
import { BasketRecommendation } from "./useProductRecommendations"

export const useBasketProductActions = () => {
  const dispatch = useAppDispatch()
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    BasketRecommendation[]
  >([])

  const toggleSample = (
    sampleId: string,
    samples: BasketSample[],
    basket: Basket
  ) => {
    if (basket.samples.samples.some((x) => x.id === sampleId)) {
      dispatch(
        setSamples({
          samples: [],
          notes: "",
        })
      )
      return
    }

    const sample = samples.find((x) => x.id === sampleId)
    if (!sample) return
    dispatch(
      setSamples({
        samples: [sample],
        notes: "",
      })
    )
  }

  const handleBasketItemRemove = (item: BasketItem) =>
    dispatch(removeFromBasket([item]))

  const handleBasketItemMoveToWishlist = (item: BasketItem) => {
    if (!item.variant) {
      throw new Error("Missing variant item")
    }
    // todo: re enable
    // dispatch(addItemToUserWishlist(item.variant.info.variantId, item.variant))
    handleBasketItemRemove(item)
  }

  const handleBasketItemQuantityChange = (
    item: BasketItem,
    newQuantity: number
  ) =>
    dispatch(
      changeQuantity({
        item,
        newQuantity,
      })
    )

  const handleBasketItemVariantChange = (
    item: BasketItem,
    newVariant: ProductVariant
  ) =>
    dispatch(
      changeVariant({
        item,
        newVariant,
      })
    )

  const handleBasketItemGiftSelect = (item: BasketItem, isGift: boolean) =>
    dispatch(
      toggleGift({
        item,
        newValue: isGift,
      })
    )

  const handleAddRecommendedProduct = (item: BasketRecommendation) => {
    setSelectedRecommendation([...selectedRecommendation, item])
    dispatch(
      addToBasket({
        product: item.item,
        productVariant: item.item.defaultVariant,
        quantity: 1,
        source: "basket-recommendations",
      })
    )
  }

  const handleRemoveRecommendedProduct = (
    item: BasketRecommendation,
    basket: Basket
  ) => {
    setSelectedRecommendation(
      selectedRecommendation.filter(
        (x) => x.item.info.productId !== item.item.info.productId
      )
    )
    dispatch(
      removeFromBasket(
        basket.items.filter(
          (x) =>
            x.variant?.info.variantId ===
            item.item.defaultVariant.info.variantId
        )
      )
    )
  }

  return {
    toggleSample,
    handleBasketItemRemove,
    handleBasketItemMoveToWishlist,
    handleBasketItemQuantityChange,
    handleBasketItemVariantChange,
    handleBasketItemGiftSelect,
    handleAddRecommendedProduct,
    handleRemoveRecommendedProduct,
    hasRecommendedProducts: selectedRecommendation.length > 0,
  }
}
